module.exports = __webpack_public_path__ + "static/media/video-slash.f3215a33.svg";